import React from 'react';
import '../../scss/social_icons.scss';

export interface SocialLink {
  platform: string;
  url: string;
  iconSrc: string;
}

const DEFAULT_SOCIAL_LINKS: SocialLink[] = [
  { platform: "LinkedIn", url: "https://www.linkedin.com/company/centrum-cyberbezpiecze%C5%84stwa-wsiiz/?originalSubdomain=pl", iconSrc: "/linkedin-50.png" },
  // { platform: "X", url: "#", iconSrc: "/x-50.png" },
  { platform: "Instagram", url: "https://www.instagram.com/centrum_cyberbezpieczenstwa/", iconSrc: "/ig-50.png" },
  { platform: "Facebook", url: "https://www.facebook.com/people/Centrum-Cyberbezpiecze%C5%84stwa-WSIiZ/61583205274795/#", iconSrc: "/fb-50.png" },
];

interface SocialIconsProps {
  className?: string; 
}

export const SocialIcons: React.FC<SocialIconsProps> = ({ className = "" }) => {
  return (
    <div className={`social-icons-list ${className}`.trim()}>
      {DEFAULT_SOCIAL_LINKS.map((link) => (
        <a 
          key={link.platform} 
          href={link.url} 
          className="social-icon-link" 
          aria-label={link.platform}
          target="_blank" 
          rel="noopener noreferrer"
        >
          <img src={link.iconSrc} alt={`${link.platform} icon`} />
        </a>
      ))}
    </div>
  );
};